import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Grid, Box, FormGroup, FormControlLabel, Checkbox,
    TextField,
    Button, Card,
    Typography, useMediaQuery,
    CardContent,
    Stack
} from "@mui/material";
import { Formik } from 'formik';
import { fetchData, postData, postFormData } from '../../../../redux/apiSlice';
import { useDispatch } from 'react-redux';
import swal from "sweetalert";
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../../Components/Loader/Loader';
import * as Yup from 'yup';
import _ from "lodash";
function ServiceStep5({ formData, oldFormData,setTabValue, fetchMediaService, onPrevious, }) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [mediaServiceVideosTemplate, setMediaServiceVideosTemplate] = useState([]);
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const dispatch = useDispatch();


    const validationSchema = Yup.object().shape({
        meeting_link: Yup.string().when('checked', {
            is: true,
            then: (schema) => schema.required('Please enter meeting link.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    })
    // useEffect(() => {
    // let imageUrl;

    // if (formData.reference_image) {
    //     imageUrl = URL.createObjectURL(formData.reference_image);
    // }

    // return () => {
    //     if (imageUrl) {
    //     URL.revokeObjectURL(imageUrl);
    //     }
    // };
    // }, [formData.reference_image]);


    const fetchMediaServiceVideosTemplate = async () => {
            handleFreezStart();
            const apiUrl = '/mediaServiceVideosTemplate';
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if (res) {
                setMediaServiceVideosTemplate(res.data);
                handleFreezStop();
            }else{
                handleFreezStop();
            }
        }
        useEffect(() => {
            fetchMediaServiceVideosTemplate();
        }, [])
        
    return (
        <>
            <Formik
                initialValues={{
                }}
                onSubmit={async (values, errors) => {
                    handleFreezStart();
                    const apiUrl = '/storeMediaService';
                    const formDataToSend = new FormData();
                    const finalValues = { 
                        ...formData, 
                        ...values, 
                    };
                    const selectedOptions = finalValues.selectedOptions;
                    const linksObject = {};
                    if (selectedOptions.website && finalValues.websiteLink) {
                        linksObject.website =finalValues.websiteLink;
                    }
                    if (selectedOptions.instagram && finalValues.instagramLink) {
                        linksObject.instagram =finalValues.instagramLink;
                    }
                    if (selectedOptions.youtube && finalValues.youtubeLink) {
                        linksObject.youtube =finalValues.youtubeLink;
                    }
                    if (selectedOptions.other && Array.isArray(finalValues.otherLinks)) {
                        linksObject.other = finalValues.otherLinks.filter(link => link);
                    }

                    // Set the link array to brand_name (or another key as needed)
                    finalValues.business_url = JSON.stringify(linksObject);
                    console.log("finalValues.business_url",finalValues.business_url);
                    for (const key in finalValues) {
                        const value = finalValues[key];

                        if ((key === 'logo' || key === 'reference_image') && value instanceof File) {
                            formDataToSend.append(key, value);
                        } else if (key === 'videos') {
                            // Stringify the whole array of objects
                            formDataToSend.append(key, JSON.stringify(value));
                        } else if (Array.isArray(value)) {
                            // For arrays like `video_ids` (which are just primitive values)
                            value.forEach(item => formDataToSend.append(`${key}[]`, item));
                        } else {
                            formDataToSend.append(key, value ?? '');
                        }
                    }

                    try {
                        const res = await dispatch(postFormData({ apiUrl, formData: formDataToSend })).unwrap();
                        if (res && res.success === true) {
                            swal({
                                title: "Success",
                                text: res.message,
                                icon: "success",
                                button: "Ok",
                            }).then(() => {
                                handleFreezStop();
                                setTabValue("2");
                                fetchMediaService();
                            });
                        } else {
                            swal({
                                title: "Failure",
                                text: res.message || "Something went wrong",
                                icon: "error",
                                button: "Ok",
                            });
                            handleFreezStop();
                        }
                    } catch (err) {
                        handleFreezStop();
                        console.error("API Error:", err);
                        if (err?.errors) {
                            alert(Object.values(err.errors).flat().join('\n'));
                        } else {
                            alert("Something went wrong!");
                        }
                    }
                }}
            >
                {({ handleSubmit, handleChange, handleBlur, values, setFieldValue, touched, errors }) => (
                <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                    <Card p={isMobile ? 0 : 2} sx={{ width: "100%",boxShadow:"none",border:"none" }}>
                        <CardContent>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant='h6' fontWeight={700}>{formData.has_logo == 1 && formData.videos.length === 0
                                ? "": "YOUR REQUESTED SERVICES"}</Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                {formData.has_logo == 1 ?
                                    <>
                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <Typography variant='body1'><b>1.Logo</b></Typography>
                                    </Grid>
                                    <Grid item lg={9} md={9} sm={12} xs={12}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                                {formData.logo && (
                                                    <>
                                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                            <Typography> Logo</Typography>
                                                        </Grid>
                                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                            <Box
                                                                component="img"
                                                                src={URL.createObjectURL(formData.logo)}
                                                                alt="Reference Logo"
                                                                sx={{
                                                                    width: 100,
                                                                    height: 'auto',  
                                                                }}
                                                            />
                                                        </Grid> 
                                                    </>  
                                                    )} 
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    </>
                                :
                                <>
                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <Typography variant='body1'><b>1. Logo Designing</b></Typography>
                                    </Grid>
                                    <Grid item lg={9} md={9} sm={12} xs={12}>
                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                        <Grid item lg={4} md={4} sm={12} xs={12}>
                                                {/* {formData.company_name && ( */}
                                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                <Typography> Company Name: <b>{formData.company_name}</b></Typography>
                                            </Grid>
                                                {/* )} */}
                                                {/* {formData.tagline && ( */}
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Typography> Tag Line:<b> {formData.tagline?formData.tagline:"N/A"}</b></Typography>
                                                </Grid>
                                                {/* )} */}
                                        </Grid>
                                        <Grid item lg={4} md={4} sm={12} xs={12}>
                                            {/* {formData.secondary_color && ( */}
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Typography><Stack direction="row">Primary Color: <span style={{marginLeft:"35px"}}>
                                                        <Box
                                                            sx={{
                                                                width: 20,
                                                                height: 20,
                                                                borderRadius: 0,
                                                                backgroundColor: formData.primary_color,
                                                                border: 'none',
                                                            }}
                                                        /></span> </Stack>
                                                    </Typography>
                                                </Grid>
                                            {/* )} */}
                                            {/* {formData.secondary_color && ( */}
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Typography> <Stack direction="row">Secondary Color:
                                                        <span style={{marginLeft:"13px"}}>
                                                            <Box
                                                                sx={{
                                                                    width: 20,
                                                                    height: 20,
                                                                    borderRadius: 0,
                                                                    backgroundColor: formData.secondary_color,
                                                                    border: 'none',
                                                                }}
                                                            /></span> </Stack>
                                                    </Typography>
                                                </Grid>
                                            {/* )} */}
                                        </Grid>
                                        <Grid item lg={4} md={4} sm={12} xs={12}>
                                            {formData.reference_image && (
                                                <>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                        <Typography> Reference image</Typography>
                                                    </Grid>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                        <Box
                                                            component="img"
                                                            src={URL.createObjectURL(formData.reference_image)}
                                                            alt="Reference Logo"
                                                            sx={{
                                                                width: 100,
                                                                height: 'auto',  
                                                            }}
                                                        />
                                                    </Grid> 
                                                </>  
                                                )} 
                                        </Grid>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography>Suggestions: <b>{formData.suggestions?formData.suggestions:"N/A"}</b></Typography>
                                    </Grid>
                                    </Grid>
                                </>
                                }
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                {formData.videos?.map((video, index) => (
                                    <Grid item lg={12} md={12} sm={12} xs={12} key={video.video_id}>
                                        <Typography  textTransform={"capitalize"}>
                                            <b>Video {index + 1}. {video.title}</b>
                                        </Typography>
                                        {video.selectedOption === "coaching" ? (
                                            <Box mt={1} mb={2} p={2} sx={{ border: "1px solid #ccc", borderRadius: 2, backgroundColor: "#f9f9f9" }}>
                                                <Typography variant="body1"  textTransform={"capitalize"} sx={{ whiteSpace: 'pre-line' }}>
                                                {video.video_script || "No script provided."}
                                                </Typography>
                                            </Box>
                                        ) : (
                                            mediaServiceVideosTemplate
                                                ?.filter(
                                                (template) =>
                                                    template.md_service_id === video.service_id &&
                                                    template.id === video.template_id
                                                )
                                                .map((item) => (
                                                <Box mt={1} mb={2} p={2} sx={{ border: "1px solid #ccc", borderRadius: 2, backgroundColor: "#f9f9f9" }}>
                                                    <Typography variant="body1"  textTransform={"capitalize"} sx={{ whiteSpace: 'pre-line' }}>
                                                    {item.script}
                                                    </Typography>
                                                </Box>
                                            ))
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                            {formData.has_logo == 1 && formData.videos.length === 0
                                ?
                                <Typography variant="body1"  sx={{ whiteSpace: 'pre-line' }}>
                                    You Have Provided Your Logo. However, Video Service Have Not Been Availed At This Time. If You Wish To Opt For These Service In Future, You May Do So At Your Convenience.
                                </Typography>
                                 : ""}
                            </Grid>
                        </CardContent>
                    </Card>
                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} gap={2} justifyContent={isMobile ? "center" : "left"}>
                        <Button variant="contained" color='primary' sx={{ minWidth: 250, fontWeight: "bold", fontSize: "15px" }} type='submit' disabled={_.isEqual(formData, oldFormData)}>SAVE MY REQUEST</Button>
                        <Button variant="text" onClick={onPrevious} color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} >previous step</Button>
                    </Grid>
                </form>
                )}
            </Formik>
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
        </>
    )
}
export default ServiceStep5;